import { useCallback } from "react";
import { usePolling } from "./use-polling";
import { inboxMessagesApi } from "@/api/inbox-messages";
import { POLLING_INTERVAL_MESSAGES } from "@/lib/constants";
import type { InboxMessage } from "@/types/inbox-message";

export function useInboxMessages(inboxId: number | null) {
  const fetcher = useCallback(async () => {
    if (!inboxId) return [];
    const res = await inboxMessagesApi.list({ id_inbox: String(inboxId) });
    return res.data || [];
  }, [inboxId]);

  const { data, loading, error, refetch } = usePolling<InboxMessage[]>(
    fetcher,
    POLLING_INTERVAL_MESSAGES,
    !!inboxId,
  );

  return { messages: data || [], loading, error, refetch };
}
